// extracted by mini-css-extract-plugin
module.exports = {"debugInfo":"debug-info_debugInfo__liH7T","button":"debug-info_button__JO2Hx"};